import React from 'react';
import { motion } from 'framer-motion';
import { Map, ArrowRight } from 'lucide-react';
import { RADIUS } from '../../../config/designTokens';
interface JourneyEmptyStateProps {
  onNavigate: (view: string) => void;
}
export function JourneyEmptyState({
  onNavigate
}: JourneyEmptyStateProps) {
  return <div className="flex flex-col items-center text-center pt-12 pb-24 px-4 relative z-10" data-id="element-1911" data-mp="3kz3nbwuiec">
      <motion.div initial={{
      scale: 0.9,
      opacity: 0
    }} animate={{
      scale: 1,
      opacity: 1
    }} className="max-w-sm w-full" data-id="element-1912" data-mp="3s753csayyfbw">
        <div className="relative w-32 h-32 mx-auto mb-6" data-id="element-1913" data-mp="3i7mm4jmg17nj">
          <div className="absolute inset-0 bg-blue-100 rounded-full animate-pulse" data-id="element-1914" data-mp="3ia9297negvhd" />
          <div className="absolute inset-2 bg-blue-50 rounded-full flex items-center justify-center border-4 border-white shadow-sm" data-id="element-1915" data-mp="3dbforf8454h7">
            <Map className="w-12 h-12 text-blue-400" data-id="element-1916" data-mp="1bi80hgaivcj6" />
          </div>
        </div>

        <h2 className="text-2xl font-black text-slate-800 mb-3" data-id="element-1917" data-mp="ipjzjomsbja8">
          Jouw reis begint hier!
        </h2>
        <p className="text-slate-600 font-medium mb-8 leading-relaxed" data-id="element-1918" data-mp="nodgxs56zufo">
          Je hebt nog geen vaardigheden geoefend. Zodra je begint, verschijnt
          hier jouw persoonlijke avonturenpad.
        </p>

        <button onClick={() => onNavigate('modules')} className={`w-full py-4 bg-blue-500 text-white font-black text-lg ${RADIUS.button} shadow-md hover:bg-blue-600 active:scale-95 transition-all flex items-center justify-center gap-2`} data-id="element-1919" data-mp="dpxo9kqiod42">
          Start je reis
          <ArrowRight className="w-5 h-5" data-id="element-1920" data-mp="rqi9sontgn19" />
        </button>
      </motion.div>
    </div>;
}